module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "width": (_vm.width + "%")
    }
  }, [_c('div', {
    staticClass: "root"
  }, [_vm._l((_vm.newData), function(d, i) {
    return _c('div', {
      key: i,
      class: _vm.editable ? 'data' : '',
      attrs: {
        "cell-type": "list",
        "title": _vm.editable ? ("Click to Delete value: " + d) : ''
      },
      on: {
        "click": function($event) {
          _vm.editable ? _vm.deleteDataAt(i) : void ''
        }
      }
    }, [_vm._v(_vm._s(d))])
  }), _vm._v(" "), (_vm.addItem == null && _vm.editable) ? _c('div', {
    key: "plus",
    staticClass: "plus",
    attrs: {
      "title": "add a new data"
    },
    on: {
      "click": _vm.adding
    }
  }, [_vm._v("+")]) : (_vm.editable) ? _c('div', {
    key: "adding",
    staticClass: "adding"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.addItem),
      expression: "addItem",
      modifiers: {
        "lazy": true
      }
    }],
    attrs: {
      "pattern": "pattern",
      "placeholder": _vm.tips || ("/" + _vm.pattern + "/")
    },
    domProps: {
      "value": (_vm.addItem)
    },
    on: {
      "change": function($event) {
        _vm.addItem = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "save",
    on: {
      "click": _vm.add
    }
  }, [_vm._v("Save")])]) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d6ad1fe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/CommissionSetting2/IB/AlertIgnore/EditableListCell.vue
// module id = 1099
// module chunks = 1